import './index.scss'
import { Controller as BaseController } from 'stimulus'

export class Controller extends BaseController {
    static targets = ['textArea', 'liveRegion']

    setErrorMessage(event) {
      this.textAreaTarget.setCustomValidity(event.detail)
      this.liveRegionTarget.innerHTML = event.detail
    }
}
